import { useQuery } from '@tanstack/react-query'

import type { Notifications } from '@/api/notifications'
import { notificationResources } from '@/api/notifications'
import queries from '@/api/queries'

const NOTIFICATIONS_INITIAL_DATA: Notifications = {
  newDeviceOrderAmount: 0,
  newSubscriptionOrderAmount: 0,
  newShopOrderAmount: 0,
  pendingInjuryReportAmount: 0,
  newOrdersAmount: 0,
  pendingTradeInOrderActions: 0,
}

export const useNotifications = () => {
  const { data } = useQuery(queries.notifications(), notificationResources.get)

  return data || NOTIFICATIONS_INITIAL_DATA
}
